import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Modal, Row, Col, Table, Button, Alert } from "react-bootstrap";
import { FaEdit, FaTrash, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { FcAcceptDatabase } from "react-icons/fc";
import api from "../../services/api";
import ico_pdf_download from "../../assets/ico_pdf_download.png";
import publicIp from "react-public-ip";

import ender from "../../tools/ender";
import { acesso } from "../../tools/SAP";
import { retornaEmail } from "../../tools/auxiliar";
import "./styles.css";

export default function Contribuicao({ history, location }) {
  const [audiencia, setAudiencia] = useState([]);
  const [contribuicoes, setContribuicoes] = useState([]);
  const [itensObjeto, setItensObjeto] = useState([]);
  const [pessoa, setPessoa] = useState("");
  const [dispositivo, setDispositivo] = useState(0);
  const [original,setOriginal]= useState('');
  const [textoContribuicao,setTextoContribuicao]= useState('');
  const [justificativa,setJustificativa]= useState('');
  const [anexo,setAnexo]= useState(null);
  const [mensagem, setMensagem]= useState("");
  const [msgGeral, setMsgGeral]= useState("");
  const [tipoMensagem, setTipoMensagem] = useState("danger");
  const [idContribuicao, setIdContribuicao] = useState(0);
  const { consulta_id } = useParams();
  const [idAudiencia] = useState(consulta_id);
  const email = retornaEmail();
  const [usuarioANA] = useState(localStorage.getItem("ANA"));
  const [edicao, setEdicao] = useState(false);
  const [classifica, setClassifica] = useState('DT_SEGUNDOS');
  const [ascendente, setAscendente] = useState(true);
  const [idParticipante, setIdParticipante] = useState(0);
  const [encerrado, setEncerrado] = useState("");
  const [interno, setInterno] = useState("");
  const [gerenciar, setGerenciar] = useState(false);
  const [showEdicao, setShowEdicao] = useState(false);
  const [ipv4,setIpv4] = useState("");

  localStorage.removeItem("idAudiencia");
  
  if (!email) {
    window.location.href=`/Consulta/${idAudiencia}`;
  }

  if (encerrado !== ""){
    if (encerrado !== "P") {
      window.location.href="/";
    }
  }
  if (interno === "S"){
    if (usuarioANA !== "S") {
      window.location.href="/";
    }
  }

  useEffect(() => {
    async function loadAudiencia() {
      if (!isNaN(idAudiencia)) {
        const response = await api.get(`/api/audiencia/${idAudiencia}`);
        setAudiencia(response.data[0]);
        setEncerrado(response.data[0].ST_ENCERRADO);
        setInterno(response.data[0].ST_INTERNO);
      }
    }
    loadAudiencia();
  }, [idAudiencia]);

  useEffect(() => {
    async function loadItensObjeto() {
      if (idAudiencia) {
        const response = await api.get(
          `/api/audiencia/itemObjeto/${idAudiencia}`
        );
        setItensObjeto(response.data);
      }
    }
    loadItensObjeto();
  }, [idAudiencia]);

  useEffect(() => {
    async function loadContribuicoes() {
      if (idAudiencia && idParticipante) {
        const response = await api.get(
          `/api/audiencia/contribuicoes/${idAudiencia}/${idParticipante}`
        );
        setContribuicoes(response.data);
      }
    }
    loadContribuicoes();
  }, [idAudiencia, idParticipante, idContribuicao]);

  useEffect(() => {
    async function loadPessoa() {
      if (email){
        const response = await api.get(`/api/pessoa/${email}/publico`);
        setPessoa(response.data[0]);
      }
    }
    loadPessoa();
  }, [email]);

  useEffect(() => {
    async function trataParticipante() {

      if (pessoa && pessoa.NO_EMAIL.toLowerCase() === email.toLowerCase()) {
        const data = {
            'Nome': pessoa.NO_PESSOA,
            'Email': pessoa.NO_EMAIL,
            'Telefone': pessoa.TP_TELEFONE,
            'Celular': pessoa.TP_CELULAR,
            'Instituicao': pessoa.NO_INSTITUICAO,
            'Cargo': "",
            'CPF': pessoa.NU_CPF_CNPJ
          };
          const response = await api.post(
            `/api/audiencia/participante/${idAudiencia}`,
            data);
          var participante = response.data[0];
          setIdParticipante(participante.ID_PARTICIPANTE);
      }  
    }
    trataParticipante();
  }, [pessoa, idAudiencia, email]);

  useEffect(() =>
  {
    async function retornaIP(){
      setIpv4(await publicIp.v4() || "");
    }
    retornaIP();
  }, []);

  if (ipv4){
    acesso(ipv4,location.pathname,idAudiencia);
  }

  async function handleGravarContribuicao() {
    if (criticaFormulario() === true){
      const formData = new FormData();
      formData.append("idItemObjeto", dispositivo);
      formData.append("TextoContribuicao", textoContribuicao);
      formData.append("Justificativa", justificativa);
      formData.append("Anexo", anexo);
      if (edicao && idContribuicao > 0){
        await api.put(
          `/api/audiencia/contribuicao/${idContribuicao}`,
          formData
        );
      }
      else {
        const response = await api.post(
          `/api/audiencia/contribuicao/${idParticipante}`,
          formData
        );
      setIdContribuicao(response.data[0]["idContribuicao"]);
      }
      limparDadosFormulario();
      setMsgGeral("Contribuição recebida! Obrigado por contribuir com as decisões da ANA!");
      setTipoMensagem("success");
    }
  };

  function criticaFormulario(){
    setMensagem("");
    var msg = "Erro: ";
    if (dispositivo === "0"){
      msg +="Selecione o dispositivo da Proposta para o qual deseja contribuir; ";
    }
    if (textoContribuicao.length < 4){
      msg +="Texto da contribuição obrigatório; "
    }
    if (justificativa.length < 4){
      msg +="Texto da justificativa obrigatório; "
    }
    if (anexo) {
      msg += checkExtensao();
    }
    if (msg.length > 6){
      setMensagem(msg);
      setTipoMensagem("danger")
      return false;
    }
    else {
      return true;
    }
  }

  function checkExtensao(){
    const ext = anexo.name.substring(anexo.name.lastIndexOf('.') + 1).toLowerCase();   
    const validos = [
      "gif","jpg","jpeg","png","doc","docx","pdf","odt","xls","xlsx","zip","rar","txt","rtf",
    ]
    const verifica = validos.filter(v => v === ext);
    if (verifica.length>0) {
        return "";
    } else {
        return " Tipo do arquivo inválido";
    }
}

  function handleClickEdicao(id) {
    let contr = contribuicoes.filter(contrib => {return contrib.ID_CONTRIBUICAO === id});
    setMensagem("");
    setMsgGeral("");
    setDispositivo(contr[0].ID_ITEM_OBJETO);
    setOriginal(contr[0].DS_TEXTO_ORIGINAL);
    setTextoContribuicao(contr[0].DS_TEXTO_INSTITUCIONAL);
    setJustificativa(contr[0].DS_TEXTO_JUSTIFICATIVA);
    setIdContribuicao(contr[0].ID_CONTRIBUICAO);
    setEdicao(true);
    setShowEdicao(true);
  }

  async function handleClickExclusao(idContribuicao) {
    setMsgGeral("");
    await api.delete(
      `/api/audiencia/contribuicao/${idContribuicao}`
    );
    setIdContribuicao(idContribuicao);
    limparDadosFormulario();
  }

  function handleCancelaEdicao() {
    limparDadosFormulario();
    setEdicao(false);
    setShowEdicao(false);
  }

  function limparDadosFormulario() {
    setOriginal([]);
    setTextoContribuicao([]);
    setJustificativa([]);
    setAnexo(null);
    setContribuicoes([]);
    setDispositivo(0);
    setIdContribuicao(idContribuicao+1);
    setShowEdicao(false); 
    if (gerenciar && contribuicoes.length===0) {
      setGerenciar(false);
    }
  }
  function handleSelecionaDispositivo(id) {
    const descricao = itensObjeto.filter(item => {return id === item.ID_ITEM_OBJETO})[0].NO_ITEM_OBJETO;
    setOriginal(descricao);
    setDispositivo(id);
    setShowEdicao(true);
    setMsgGeral("");
  }
  function handleClassificacao(cpo){
    setClassifica(cpo);
    if (ascendente){
      setAscendente(false);
    } else {
      setAscendente(true);
    }
  }
  function formulaClassicacao(a,b){
    if (ascendente){
      return (a[classifica] < b[classifica] ? -1 : (a[classifica] > b[classifica] ? 1 : 0));
    } else {
      return (a[classifica] > b[classifica] ? -1 : (a[classifica] < b[classifica] ? 1 : 0));
    }
  }

  return (
    <>
      <Container> 
      <Row>
        <Col sm={12}>
          <div className="voltar">
            <a href={`/Consulta/${idAudiencia}`}>voltar</a>
          </div>
        </Col>
        </Row>
        <Row>
          <Col>
            <div className="quadro">
              <h3>
                {audiencia.DS_MODALIDADE + " nº "}
                {audiencia.NU_AUDIENCIA} / {audiencia.DT_ANO_AUDIENCIA}
              </h3>
            </div>
          </Col>
        </Row>
        <Modal 
          show={ showEdicao } 
          backdrop="static"
          keyboard={false}
          aria-labelledby="contained-modal-title-vcenter" 
          size="lg" 
          animation={true}>
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h3>Informe sua contribuição:</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <form id="formContribuicao">
              <Row>
                <Col sm="2">
                  <label htmlFor="Dispositivo">Dispositivo:</label>
                </Col>
                <Col sm="10">
                  <textarea
                    id="Dispositivo"
                    className="Normal"
                    type="text"
                    name="Dispositivo"
                    value={original}
                    onChange={event => setOriginal(event.target.value)}
                    readOnly
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <label htmlFor="Contribuicao">Contribuição:*</label>
                </Col>
                <Col sm="10">
                  <textarea
                    id="TextoContribuicao"
                    className="Requerido"
                    type="text"
                    placeholder="Sua contribuicao"
                    onBlur={e => {
                      const cpo = document.getElementById("TextoContribuicao").value;
                      if (cpo.length > 1)
                        document.getElementById("TextoContribuicao").className =
                          "Normal";
                      else
                        document.getElementById("TextoContribuicao").className =
                          "Requerido";
                    }}
                    value={textoContribuicao}
                    onChange={event => setTextoContribuicao(event.target.value)}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <label htmlFor="Justificativa">Justificativa:*</label>
                </Col>
                <Col sm="10">
                  <textarea
                    id="Justificativa"
                    className="Requerido"
                    type="text"
                    placeholder="Justificativa"
                    onBlur={e => {
                      const cpo = document.getElementById("Justificativa").value;
                      if (cpo.length > 1)
                        document.getElementById("Justificativa").className =
                          "Normal";
                      else
                        document.getElementById("Justificativa").className =
                          "Requerido";
                    }}
                    value={justificativa}
                    onChange={event => setJustificativa(event.target.value)}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="2">
                  <label>Anexo:</label>
                </Col>
                <Col sm="10">
                  <input
                    id="Anexo"
                    className="Normal"
                    type="file"
                    accept=".gif,.jpg,.jpeg,.png,.doc,.docx,.pdf,.odt,.xls,.xlsx,.zip,.rar,.txt,.rtf"
                    placeholder="Anexo"
                    onChange={event => setAnexo(event.target.files[0])}
                  />
                </Col>
              </Row>
              <Row className={mensagem ? "mostrar" : "naoMostrar"}>
                <Col sm="12">
                  <Alert variant={tipoMensagem}>
                      {mensagem}
                  </Alert>
                </Col>
              </Row>
              <Row>
                <Col sm="12" className="observacao">
                  Os itens marcados com <strong>*</strong> (asterisco) são obrigatórios!
                </Col>
              </Row>
            </form>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="cancelar"
            variant="secondary"
            onClick={() => handleCancelaEdicao()}
          >
            Cancelar
          </Button>
          <Button
            id="enviarContribuicao"
            variant="success" 
            onClick={() => handleGravarContribuicao()}
          >
            Enviar
          </Button>
        </Modal.Footer>
      </Modal>
        <div className={dispositivo > 0 ? "quadro Mostrar" : "quadro naoMostrar"}>
        </div>
        <div className="quadro">
          <Row className={contribuicoes.length>0?"mostrar": "naoMostrar"}>
            <Col sm={10}>
                  <h3 className={contribuicoes}>Contribuições já realizadas: {contribuicoes.length}
                    &nbsp;&nbsp;
                    <a 
                      href={`http://audienciapublica.ana.gov.br/ExportaContribuicaoPDF.php?txtAudiencia=${idAudiencia}&txtTipo=${idParticipante}`}
                      target="_blank" rel="noopener noreferrer">
                        <img src={ ico_pdf_download } 
                        alt = "Exportação para PDF" 
                        data-toggle="tooltip"
                        title="Clique aqui gerar PDF com suas contribuições" 
                        className="iconeExporta" />
                    </a>
                  </h3>
            </Col>
            <Col sm={2} className="linhaBotao">
              <Button className={gerenciar ? "naoMostrar" : "mostrar"} 
                data-toggle="tooltip"
                title="Clique aqui para gerenciar suas contribuições"  
                  variant="secondary" 
                  onClick={() => setGerenciar(true)}
                >
                  Gerenciar
              </Button>
              <Button  className={gerenciar ? "mostrar" : "naoMostrar"} 
                  data-toggle="tooltip"
                  title="Clique aqui para fechar quadro de gerenciamento contribuições"  
                  variant="secondary" 
                  onClick={() => setGerenciar(false)}
                >
                  Fechar
              </Button>
            </Col>
          </Row>
          <Row  className={contribuicoes.length===0?"mostrar": "naoMostrar"}>
            <Col sm={12}>
              <h3>Ainda não houve contribuição</h3>
            </Col>
          </Row>
        </div>
        <div
          className={gerenciar ? "mostrar quadro" : "quadro naoMostrar"}
        >
          <Row>
            <Col sm="12">
              <h3>Gerencie suas contribuições:</h3>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Table id="tableContent" striped bordered hover size="sm">
                <thead>
                  <tr className="tituloContribuicao">
                    <th width="10%">
                      <span
                        className="Aponta"
                        data-toggle="tooltip"
                        title="Clique aqui para classificar"  
                        onClick={() => handleClassificacao("DT_SEGUNDOS")}
                      >
                        Data &nbsp;&nbsp;
                        {classifica === "DT_SEGUNDOS" ? ascendente ? <FaChevronUp /> : <FaChevronDown /> : ""}
                      </span> 
                    </th>
                    <th width="20%">
                      <span
                        className="Aponta"
                        data-toggle="tooltip"
                        title="Clique aqui para classificar"  
                        onClick={() => handleClassificacao("DS_TEXTO_ORIGINAL")}
                      >
                        Dispositivo &nbsp;&nbsp;
                        {classifica === "DS_TEXTO_ORIGINAL" ? ascendente ? <FaChevronUp /> : <FaChevronDown /> : ""}
                      </span> 
                    </th>
                    <th width="35%">
                      <span
                        className="Aponta"
                        data-toggle="tooltip"
                        title="Clique aqui para classificar"  
                        onClick={() => handleClassificacao("DS_TEXTO_INSTITUCIONAL")}
                      >
                        Contribuição &nbsp;&nbsp;
                        {classifica === "DS_TEXTO_INSTITUCIONAL" ? ascendente ? <FaChevronUp /> : <FaChevronDown /> : ""}
                      </span> 
                    </th>
                    <th width="20%">
                      <span
                        className="Aponta"
                        data-toggle="tooltip"
                        title="Clique aqui para classificar"  
                        onClick={() => handleClassificacao("DS_TEXTO_JUSTIFICATIVA")}
                      >
                        Justificativa &nbsp;&nbsp;
                        {classifica === "DS_TEXTO_JUSTIFICATIVA" ? ascendente ? <FaChevronUp /> : <FaChevronDown /> : ""}
                      </span> 
                    </th>
                    <th width="5%">
                      Anexo
                    </th>
                    <th width="10%">                    
                    </th>
                  </tr>
                </thead>
                <tbody  className="table-normal">
                  {contribuicoes.sort((a, b) => formulaClassicacao(a,b))
                      .map((contrib, index) => ( 
                    <tr key={contrib.ID_CONTRIBUICAO}>
                      <td>
                        {contrib.DT_CADASTRO}
                      </td>
                      <td>
                        {contrib.DS_TEXTO_ORIGINAL.substr(0,500)}
                      </td>
                      <td>
                        {contrib.DS_TEXTO_INSTITUCIONAL.substr(0,500)}
                      </td>
                      <td> 
                        {contrib.DS_TEXTO_JUSTIFICATIVA.substr(0,500)}
                      </td>
                      <td>
                        <a href={ender.file(contrib.CA_ARQUIVO)} 
                          className={contrib.CA_ARQUIVO? "mostrar": "naoMostrar"}
                          target="_blank" 
                          rel="noopener noreferrer">
                            <img src={ ico_pdf_download } 
                              alt = "Exportação para PDF" 
                              data-toggle="tooltip"
                              title={`${contrib.CA_ARQUIVO} - Clique aqui para download`} 
                              className="iconeExporta" />
                        </a>
                      </td>
                      <td>
                        <span
                          className="Aponta icone"
                          data-toggle="tooltip"
                          title="Clique aqui para editar"  
                          onClick={() => handleClickEdicao(contrib.ID_CONTRIBUICAO)}
                          >
                          <FaEdit />
                        </span>
                        &nbsp; &nbsp;
                        <span
                          className="Aponta icone"
                          data-toggle="tooltip"
                          title="Clique aqui para excluir"  
                          onClick={() => handleClickExclusao(contrib.ID_CONTRIBUICAO)}>
                            <FaTrash  />
                          </span>                        
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        </div>
        <div className="quadro">
          <Row>
            <Col sm="12">
              <h3>Escolha o dispositivo a contribuir:</h3>
            </Col>
          </Row>
          {itensObjeto.map((item, index) => (
              <Row key={index} 
                className="Seleciona" 
              >
                <Col sm="1"
                  className="centralizar"
                  data-toggle="tooltip"
                  title="Clique aqui para selecionar o dispositivo"
                  onClick={() => handleSelecionaDispositivo(item.ID_ITEM_OBJETO)}
                >
                  <span 
                    className="Aponta icone"
                    data-toggle="tooltip"
                    title="Clique aqui para selecionar o dispositivo"  
                    >
                    <FcAcceptDatabase />
                  </span>
                </Col>
                <Col sm="11">
                  <textarea
                    id="ItemObjeto"
                    className="Simples"
                    type="text"
                    value={item.NO_ITEM_OBJETO}
                    readOnly
                  />
                </Col>
              </Row>
          ))}
        </div>
        <div>
          <Row><Col><br /></Col></Row>
          <Row className={msgGeral ? "mostrar" : "naoMostrar"}>
              <Col sm="12">
                  <Alert variant={tipoMensagem}>
                      {msgGeral}
                  </Alert>
              </Col>
          </Row>
          <Row className="centralizar">
              <Col sm="12">
                <Button
                  id="encerrrar"
                  variant="info"
                  onClick={() => window.location=`/Consulta/${idAudiencia}`}
                >
                  Encerrar contribuições
                </Button>
              </Col>
          </Row>              
        </div>
</Container>
    </>
  );
}
